import { render } from "./Transport.vue?vue&type=template&id=c4e76968"
import script from "./Transport.vue?vue&type=script&lang=js"
export * from "./Transport.vue?vue&type=script&lang=js"
script.render = render

export default script